import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { TemplateService } from '../../services/template.service';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../services/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CustomerService } from '../../services/customer.service';
var SearchComponent = (function () {
    function SearchComponent(apiService, authService, customerService, modalService, template, translate, router) {
        this.apiService = apiService;
        this.authService = authService;
        this.customerService = customerService;
        this.modalService = modalService;
        this.template = template;
        this.translate = translate;
        this.router = router;
        this.itemsPerPage = 40;
        this.allBranch = true;
        this.allDocType = true;
        this.allBranchList = null;
        this.branchList = null;
        this.buyerList = [];
        this.isBuyerFocus = false;
        this.startDate = null;
        this.endDate = null;
        this.totalItems = 0;
        this.selectedValues = [];
        this.allChecked = false;
        this.currentPage = 1;
        this.checked = false;
        this.loading = false;
        this.errorMsg = '';
        this.isSending = false;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.loading_all_zip = false;
        this.cancel_loading_all_zip = false;
        this.loading_all_zip_message = '';
        this.loading_all_zip_progress = 0;
        this.tableArray = [];
        this.allZipCurrent = 0;
        this.tableCol = [];
        this.approving = false;
        this.statusChoices = [];
        this.selectedStatus = '';
    }
    SearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
        this.loadTexts();
        this.rdDocumentType = this.template.getDropdown();
    };
    Object.defineProperty(SearchComponent.prototype, "currentLang", {
        get: function () {
            return this.translate.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    SearchComponent.prototype.loadTexts = function () {
        var _this = this;
        this.statusChoices = [
            { value: '', label: this.translate.instant('COMMON.ALL') },
            { value: 'active', label: this.translate.instant('COMMON.STATUS.ACTIVE') },
            { value: 'pending', label: this.translate.instant('COMMON.STATUS.PENDING') },
            { value: 'customer_approved', label: this.translate.instant('COMMON.STATUS.CUSTOMER-APPROVED') },
            { value: 'customer_rejected', label: this.translate.instant('COMMON.STATUS.CUSTOMER-REJECTED') },
            { value: 'cancelled', label: this.translate.instant('COMMON.STATUS.CANCELLED') },
        ];
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        this.tableCol = [];
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            _this.rdDocumentType = _this.template.getDropdown();
            _this.loadInput();
            _this.tableCol.push({ field: 'invoice_number', header: _this.translate.instant('FILTER.DOCUMENT-NUMBER') }, { field: 'header_issue_date', header: _this.translate.instant('FILTER.DATE-OF-ISSUE') }, { field: 'branch', header: _this.translate.instant('TABLE.BRANCH-NAME') }, { field: 'rd_doc_type', header: _this.translate.instant('FILTER.DOCUMENT-TYPE') }, { field: 'total_items_total_payment', header: _this.translate.instant('TABLE.SALES') });
            _this.tableCol = _.uniqBy(_this.tableCol, 'field');
        });
    };
    SearchComponent.prototype.loadInput = function () {
        var _this = this;
        this.selectedCompany = null;
        this.company = null;
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
            _this.company = _.uniqBy(_this.company, 'label');
        }, function (error) { return error(status); });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
        this.apiService.getBuyerDropdown().subscribe(function (response) {
            _this.buyerList = response.map(function (item) { return item.name; });
        });
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.searchButtonClicked();
    };
    Object.defineProperty(SearchComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    SearchComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate === _this.selectedCompany) {
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
            }
        });
    };
    SearchComponent.prototype.filterData = function (query, field, dataList) {
        query = query.toLowerCase().trim();
        var filtered = [];
        for (var i = 0; i < dataList.length; i++) {
            var data = dataList[i];
            if (data[field].toLowerCase().indexOf(query) >= 0) {
                filtered.push(data);
            }
        }
        return filtered;
    };
    SearchComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.loadData(params);
        this.allChecked = false;
    };
    SearchComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    SearchComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    SearchComponent.prototype.isOperation = function () {
        return this.authService.isOperation();
    };
    SearchComponent.prototype.clearSearch = function () {
        this.selectedType = null;
        this.inputText = null;
        this.buyerName = '';
        this.selectedCompany = null;
        this.branch = null;
        this.documentType = null;
        this.allDocType = true;
        this.allBranch = true;
        this.selectedBranch = null;
        this.selectedRdDocumentType = null;
        this.selectedStatus = '';
        this.sortBy = null;
        this.sortMode = null;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.searchButtonClicked();
    };
    SearchComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.loadData();
    };
    SearchComponent.prototype.loadData = function (params) {
        var _this = this;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            return;
        }
        var data = {
            status: this.selectedStatus || '',
            rd_doc_type: this.selectedRdDocumentType,
            search_box: this.inputText,
            buyer_name: this.buyerName,
            header_issue_date_start: this.startDate == null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: this.endDate == null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
            company_id: this.selectedCompany,
            branch_id: this.selectedBranch ? this.selectedBranch : null,
            items_per_page: this.itemsPerPage
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        this.loading = true;
        this.apiService.postSearch(data, params).subscribe(function (res) {
            _this.tableData = res.results;
            _this.totalItems = res.count;
            _this.selectedValues = [];
            for (var i = 0; i < _this.tableData.length; i++) {
                _this.selectedValues.push(false);
            }
            _this.loading = false;
        });
    };
    SearchComponent.prototype.DownloadSelected = function (content, doc_type) {
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i]) {
                continue;
            }
            this.tableArray.push(this.tableData[i]);
        }
        if (!_.isEmpty(this.tableArray)) {
            this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
            this.allZipCount = this.tableArray.length;
            this.cancel_loading_all_zip = false;
            if (doc_type === 'xml') {
                this.download(0, this.tableArray, 'xml_file');
            }
            else {
                this.download(0, this.tableArray, 'pdf_file');
            }
        }
    };
    SearchComponent.prototype.EnabledDownloadSelected = function () {
        return !this.allChecked;
    };
    SearchComponent.prototype.download = function (index, tableArray, url_field_name) {
        var _this = this;
        this.loading_all_zip = true;
        if (index >= tableArray.length) {
            this.loading_all_zip = false;
            this.loading_all_zip_message = this.translate.instant('TEXT.DOWNLOAD-COMPLETE') + ' ' + '(' +
                this.translate.instant('FILTER.ALL') + ' ' + tableArray.length + ' ' +
                this.translate.instant('COMMON.ITEMS') + ')';
            return;
        }
        if (this.cancel_loading_all_zip) {
            return;
        }
        var download_url = tableArray[index][url_field_name];
        // skip if download url is empty.
        if (download_url == null || download_url.length == 0) {
            this.download(index + 1, tableArray, url_field_name);
            return;
        }
        this.apiService.downloadFileFromMediaPath(download_url).subscribe(function (obj) {
            if (_this.cancel_loading_all_zip) {
                return;
            }
            // this.loading_all_zip = false;
            var filename = _this.getFileName(tableArray[index]);
            var taxImportPdfName = tableArray[index].tax_import_pdf_name;
            if (url_field_name === 'xml_file') {
                filename = filename + '.xml';
                _this.sniff('DOWNLOAD_XML', filename);
            }
            else {
                filename = taxImportPdfName ? taxImportPdfName : filename + '.pdf';
                _this.sniff('DOWNLOAD_PDF', filename);
            }
            _this.apiService.createDownloadFile(obj, filename);
            _this.allZipCurrent++;
            _this.loading_all_zip_progress = (_this.allZipCurrent / _this.allZipCount) * 100;
            // data.xmlLoading = false;
            setTimeout(function () {
                _this.download(index + 1, tableArray, url_field_name);
            }, 1000);
        }, function (error) {
            _this.loading_all_zip = false;
            _this.loading_all_zip_message = _this.translate.instant('ERROR.TRY-AGAIN');
            // data.xmlLoading = false;
        });
    };
    SearchComponent.prototype.closeDownloadAll = function () {
        this.modal.close();
        this.cancel_loading_all_zip = true;
        this.loading_all_zip = false;
        this.allZipCurrent = 0;
        this.loading_all_zip_progress = 0;
    };
    SearchComponent.prototype.getFileName = function (data) {
        var rd_doc_type = data.rd_document_type === 'other' ? data.document_type__type : data.rd_document_type;
        return data.header_invoice_number + '_' + rd_doc_type + '_' + data.issue_dt_only_date;
    };
    SearchComponent.prototype.selectDeselectAll = function (checked) {
        this.selectedValues = Array(this.tableData.length).fill(checked);
        this.allChecked = checked;
    };
    SearchComponent.prototype.isAllSelect = function () {
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i]) {
                this.allChecked = false;
                return;
            }
        }
        this.allChecked = true;
    };
    SearchComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
    };
    SearchComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    SearchComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.branch) && this.allBranch === false) {
            errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY')
                + ' ' + errorMsgList.join(', ')
                + ' ' + this.translate.instant('COMMON.CORRECT');
            return;
        }
    };
    SearchComponent.prototype.closeCancelModal = function () {
        this.modal.close();
        this.selectedDocument = undefined;
    };
    SearchComponent.prototype.openMailModal = function (event, modalSendEmail, index) {
        this.modalData = this.tableData[index];
        this.modalData.status_send_email = 'not_yet_sent';
        this.modal = this.modalService.open(modalSendEmail, { keyboard: false, centered: true });
        this.modalData.email_sent_msg = null;
    };
    SearchComponent.prototype.closeMailModal = function () {
        this.modal.close();
        this.modalData.email_sent_msg = null;
    };
    SearchComponent.prototype.sendMail = function () {
        var _this = this;
        this.isSending = true;
        var data = {
            tax_data_id: this.modalData.tax_data_id,
            email: this.modalData.buyer_email,
            cc_email: this.modalData.buyer_cc_email
        };
        this.apiService.sendEmailETaxInvoice(data).subscribe(function (res) {
            _this.modalData.email_sent_msg = res.message;
            _this.modalData.status_send_email = 'sent';
            var sniffData = "" + _this.modalData.header_invoice_number;
            _this.sniff('SEND_EMAIL', sniffData);
            _this.isSending = false;
        }, function (err) {
            _this.modalData.email_sent_msg = err.error;
            _this.modalData.status_send_email = 'blank_duplicated_invalid';
            _this.isSending = false;
        });
    };
    SearchComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'DOC_SEARCH',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    SearchComponent.prototype.reissueDocument = function (id) {
        this.router.navigate(['document', 'issue'], { queryParams: { id: id, type: 'reissue' } });
    };
    SearchComponent.prototype.getDataStatusDisplay = function (status) {
        var statusDisplay;
        switch (status) {
            case 'pending': {
                statusDisplay = this.translate.instant('COMMON.STATUS.PENDING');
                break;
            }
            case 'active': {
                statusDisplay = this.translate.instant('COMMON.STATUS.ACTIVE');
                break;
            }
            case 'customer_approved': {
                statusDisplay = this.translate.instant('COMMON.STATUS.CUSTOMER-APPROVED');
                break;
            }
            case 'customer_rejected': {
                statusDisplay = this.translate.instant('COMMON.STATUS.CUSTOMER-REJECTED');
                break;
            }
            case 'cancelled': {
                statusDisplay = this.translate.instant('COMMON.STATUS.CANCELLED');
                break;
            }
            default: {
                statusDisplay = '-';
            }
        }
        return statusDisplay;
    };
    SearchComponent.prototype.openConfirmationModal = function (modalContent, data) {
        this.selectedDocument = data;
        this.modal = this.modalService.open(modalContent, { centered: true, backdrop: 'static' });
    };
    SearchComponent.prototype.bypassApproveDocument = function () {
        var _this = this;
        if (!this.selectedDocument) {
            return;
        }
        this.approving = true;
        this.customerService.userApproveTaxData(this.selectedDocument.secret_code).subscribe(function () {
            _this.approving = false;
            _this.closeCancelModal();
            _this.loadData();
        }, function (error) {
            _this.approving = false;
            _this.closeCancelModal();
        });
    };
    SearchComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    SearchComponent.prototype.getSelectId = function () {
        var selectedId = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (this.selectedValues[i]) {
                selectedId.push(this.tableData[i].tax_data_id);
            }
        }
        return selectedId.join(',');
    };
    SearchComponent.prototype.getExportExcel = function () {
        var _this = this;
        var params = {
            search_box: this.getSelectId(),
        };
        this.apiService.getDocumentSearch(params).subscribe(function (obj) {
            var currentDate = moment().format('DD-MM-YYYY');
            var filename = currentDate + "_document_search_export.xlsx";
            _this.sniff('DOWNLOAD_XLS', filename);
            _this.apiService.createDownloadFile(obj, filename);
        });
    };
    return SearchComponent;
}());
export { SearchComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.component.ts.pre-build-optimizer.js